import ApiClient from 'lib/ApiClient';

import { FetchTagsAction } from 'state/actions/types/tagActionsTypes';

export const fetchTags = (): FetchTagsAction => ({
  type: 'FETCH_TAGS',
  payload: ApiClient.fetchTags(),
});
